import React, { useState } from "react";
import ActionBar from "../../../shared/ActionBar";
import {
  mobileBreakpoint,
  mobileHeightBreakpoint,
} from "../../../helpers/constants";
import { Icon } from "../../../shared/FormElements";
import { faSync, faBan } from "@fortawesome/free-solid-svg-icons";
import { colors } from "../../../helpers/styles";
import { formatCurrency } from "../../../helpers/utils";
import styled from "styled-components";

const actionBarPositioning = {
  position: "absolute",
  height: "auto",
  right: 0,
  top: 0,
  transform: "translate(50%, -50%)",
};

const BuyInActionBar = ({
  emitSocketMessage,
  name,
  pos,
  requestedBuyIn,
  pendingBuyIn,
  isInCents,
}) => {
  const [isApproved, setApproveBuyIn] = useState(false);

  const approveBuyIn = () => {
    setApproveBuyIn(true);
    emitSocketMessage("approve_buy_in", {
      name: name,
      amount: parseInt(requestedBuyIn),
    });
  };

  const declineBuyIn = () => {
    setApproveBuyIn(true);
    emitSocketMessage("approve_buy_in", {
      name: name,
      amount: parseInt(pendingBuyIn),
    });
  };

  const actionsList = [
    {
      name: "Accept",
      icon: faSync,
      inner: (
        <>
          {pendingBuyIn > 0 ? (
            <Icon icon={faSync} color={colors.white} size="xs" />
          ) : (
            "+"
          )}
          <BuyInWrapper>
            {formatCurrency(requestedBuyIn, isInCents)}
          </BuyInWrapper>
        </>
      ),
      dataTestId: `accept-buyin${pos}`,
      onClick: () => approveBuyIn(),
      color: colors.green,
    },
    {
      name: "Decline",
      icon: faBan,
      inner: <Icon icon={faBan} color={colors.white} size="xs" />,
      dataTestId: `decline-buyin${pos}`,
      onClick: () => declineBuyIn(),
      color: colors.red,
    },
  ];

  return (
    <ActionBar
      show={true}
      actionsList={actionsList}
      style={actionBarPositioning}
    />
  );
};

const BuyInWrapper = styled.div`
  margin-left: 1.5px;
`;

export default BuyInActionBar;
